import classcat from "classcat";
import React from "react";

import { IconArrowDown } from "@touchtech/web-baselayer-ui";

import css from "./GoToBottomButton.module.css";
import useManageGoToBottomButton from "./hooks/useManageGoToBottomButton";

type Props = {
  onClick: () => void;
  className?: string;
  isVisible: boolean;
};

const GoToBottomButton = ({ onClick, className, isVisible }: Props) => {
  const { show } = useManageGoToBottomButton({ isVisible });

  return (
    <button
      className={classcat([
        css.goToBottomButton,
        { [css.show]: show },
        className,
      ])}
      onClick={onClick}
    >
      <IconArrowDown className={css.goToBottomIcon} />
    </button>
  );
};

export default GoToBottomButton;
